
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hnaviCategory]/feature",
      function () {
        return require("private-next-pages/[hnaviCategory]/feature/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hnaviCategory]/feature"])
      });
    }
  